import React, { useState, useEffect } from "react";
import "../../../assests/css/Verda/varda-form.css";
import "../../../assests/css/Verda/bootstrap.min.css";
import "../../../assests/css/Verda/my-style.css";
import * as DateUtil from "../../../Utils/DatePicker";
import { handleDateChange } from "../../../Utils/DateFormatter";
import { useDispatch, useSelector } from "react-redux";
import { getVerdaPdf } from "../../../Redux/Actions/verdaAction";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";

let medicationVals = [
  "Humalog",
  "Novolog",
  "Humulin",
  "Novolin",
  "Lantus",
  "Toujeo",
  "Tresiba",
  "Metformin",
  "Glipizide",
  "Glimepiride",
  "Pioglitazone (Actos)",
  "Trulicity",
  "Januvia",
  "Janumet",
  "Tradjenta",
  "Farxiga",
  "Jardiance",
  "Captopril",
  "Enalapril",
  "Fosinopril",
  "Losartan",
  "Valsartan",
  "Metoprolol",
  "Digoxin",
  "Coumadin",
  "Amlodipine",
  "Chlorothiazide",
  "Furosemide",
  "Eplerenone",
  "Lisinopril",
  "Ramipril",
  "Carvedilol",
  "Hydralazine & isosorbide dinitrate",
  "Clopidogrel",
  "HCTZ",
];
export const CardioPreEnrollmentForm = (props) => {
  const planYear = useSelector((plan) =>
    plan.webApp.year?.planYear ? plan.webApp.year.planYear : plan.webApp.year
  );
  let initialState = {
    planYear:planYear,
    formType: "PREENROLL",
    preEnrollFormVO: {
      firstName: "",
      lastName: "",
      middleInitial: "",
      date: "",
      gender: "",
      dateOfBirth: "",
      diabetesInd: "",
      chfInd: "",
      cardiovascularInd: "",
      medications: [],
      otherMed1: "",
      otherMed2: "",
      otherMed3: "",
      otherMed4: "",
      otherMed5: "",
      otherMed6: "",
      illnessInd: "",
      insulinInd: "",
      pcpProviderName: "",
      pcpAddress: "",
      pcpPhoneNum: "",
      pcpFaxNum: "",
      specialistName: "",
      specialistAddress: "",
      specialistPhoneNum: "",
      specialistFaxNum: "",
      enrolleeSignature: "",
      signDate: new Date()
        .toLocaleString("en-US", {
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        })
        .split(",")[0],
    },
    careFormVO: null,
  };
  const [state, setState] = useState(initialState);
  const [other, setOther] = useState({
    other1: "",
    other2: "",
    other3: "",
    other4: "",
    other5: "",
    other6: "",
  });
  const [snackbarInfo, setSnackBarInfo] = useState({
    snackBarOpen: false,
    vertical: "bottom",
    horizontal: "bottom",
    snackBarSeverty: "",
    snackBarMsg: "",
  });
  const [disableFlag, setDisableFlag] = useState(true);
  const dispatch = useDispatch();
  const submitHandler = async () => {
    const response = await dispatch(getVerdaPdf(state));
    if (response.status === "OK") {
      const blob = "data:application/pdf;base64," + response.data;
      props.savePdfBlobs([
        {
          attachmentType: "PRE-ENROLLMENT FORM",
          attachment: blob,
          typeCode: "PEP",
        },
      ]);
      // setSnackbar(true,"Submitted Successfully.","success")
      props.isSubmitted({ cardioVascular: "Y" });
      props.closeModal();
    } else {
      setSnackbar(true, "System Error.", "error");
      props.isSubmitted({ cardioVascular: "N" });
    }
  };
  useEffect(() => {
    let { data } = props;
    let gender1 = data.sex === "M" ? "Male" : data.sex === "F" ? "Female" : "";
    let personalInfo = {
      firstName: data.firstName,
      lastName: data.lastName,
      middleInitial: data.middleInitial,
      gender: gender1,
      dateOfBirth: data.birthDate,
    };
    setState({
      ...state,
      preEnrollFormVO: { ...state.preEnrollFormVO, ...personalInfo },
    });
  }, []);
  useEffect(() => {
    let mandatoryInfos = [
      firstName,
      lastName,
      dateOfBirth,
      specialistName,
      // specialistAddress,
      // specialistPhoneNum,
      // specialistFaxNum,
      pcpProviderName,
    // pcpAddress,
      // pcpPhoneNum,
      // pcpFaxNum,
    ];
    let pcpAddressPh =[
      pcpAddress,
      pcpPhoneNum,
    ]
     let specialistAddressph =[
      specialistAddress,
      specialistPhoneNum,
     ]
    let mandatoryInds = [diabetesInd, chfInd, cardiovascularInd];
    let mandatoryAddQsns = [illnessInd, insulinInd];
    if (
      mandatoryInfos.every((m) => m !== "") &&
      mandatoryInds.some((n) => n !== "") &&
      mandatoryAddQsns.every((o) => o !== "") &&
      (pcpPhoneNum ? pcpPhoneNum.length === 14 : true )&&
      (specialistPhoneNum ?(specialistPhoneNum.length === 14 || specialistPhoneNum === 'N/A' ) : true )&& 
      pcpAddressPh.some((p) => p !== "")&&
      specialistAddressph.some((s) => s !== "")
    ) {
      setDisableFlag(false);
    } else {
      setDisableFlag(true);
    }
  }, [state]);
  const {
    firstName,
    lastName,
    middleInitial,
    date,
    gender,
    dateOfBirth,
    diabetesInd,
    chfInd,
    cardiovascularInd,
    medications,
    otherMed1,
    otherMed2,
    otherMed3,
    otherMed4,
    otherMed5,
    otherMed6,
    illnessInd,
    insulinInd,
    pcpProviderName,
    pcpAddress,
    pcpPhoneNum,
    pcpFaxNum,
    specialistName,
    specialistAddress,
    specialistPhoneNum,
    specialistFaxNum,
    enrolleeSignature,
    // signDate,
  } = state.preEnrollFormVO;
  const { other1, other2, other3, other4, other5, other6 } = other;
  const { snackBarOpen, vertical, horizontal, snackBarSeverty, snackBarMsg } =
    snackbarInfo;
  const formatPhoneNumber = (phoneNumberString) => {
    let match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
      // return match[1] + match[2] + match[3];
    }
    return phoneNumberString;
  };
  const setSnackbar = (snackBarOpen1, alertMsg, severity) => {
    setSnackBarInfo({
      ...snackbarInfo,
      snackBarOpen: snackBarOpen1,
      snackBarMsg: alertMsg,
      snackBarSeverty: severity,
    });
  };
  const handleChange = (e) => {
    let value = e.target.value.toUpperCase();
    console.log("cls", e.target.name.endsWith("Num"), "name", e.target.name);
    if (e.target.name === "specialistPhoneNum") {
      value = formatPhoneNumber(value.replace(/[^0-9,N/A]/g, ""));
    }
    if (e.target.name === "pcpPhoneNum") {
      value = formatPhoneNumber(value.replace(/[^0-9]/g, ""));
    }
    setState({
      ...state,
      preEnrollFormVO: {
        ...state.preEnrollFormVO,
        [e.target.name]: value,
      },
    });
  };
  const handleCheckBox = (e) => {
    if (medicationVals.some((m) => m === e.target.value)) {
      if (medications.some((n) => n === e.target.value)) {
        let arr = medications.filter((l) => l !== e.target.value);
        setState({
          ...state,
          preEnrollFormVO: { ...state.preEnrollFormVO, medications: arr },
        });
      } else {
        setState({
          ...state,
          preEnrollFormVO: {
            ...state.preEnrollFormVO,
            medications: [...state.preEnrollFormVO.medications, e.target.value],
          },
        });
      }
      return;
    }
    if (
      e.target.name === "other1" ||
      e.target.name === "other2" ||
      e.target.name === "other3" ||
      e.target.name === "other4" ||
      e.target.name === "other5" ||
      e.target.name === "other6"
    ) {
      setOther({
        ...other,
        [e.target.name]: e.target.checked ? e.target.value : "",
      });
      return;
    }
    setState({
      ...state,
      preEnrollFormVO: {
        ...state.preEnrollFormVO,
        [e.target.name]: e.target.checked ? e.target.value : "",
      },
    });
  };
  const handleDate = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    value = handleDateChange(value);
    setState({
      ...state,
      preEnrollFormVO: { ...state.preEnrollFormVO, [name]: value },
    });
  };
  const handleDates = (fieldId) => {
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      setDates(fieldId, e.target.value);
    });
  };

  const setDates = (fieldId, value) => {
    setState({
      ...state,
      preEnrollFormVO: { ...state.preEnrollFormVO, [fieldId]: value },
    });
  };
  return (
    <main className="page-content" id="main-content-area">
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={6000}
        onClose={() =>
          setSnackBarInfo({ ...snackbarInfo, snackBarOpen: false })
        }
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        <Alert
          onClose={() =>
            setSnackBarInfo({ ...snackbarInfo, snackBarOpen: false })
          }
          severity={snackBarSeverty}
        >
          {snackBarMsg}
        </Alert>
      </Snackbar>
      <div className="container-fluid container-xl container-bg mt-3 mb-3">
        <div className="page">
          <div className="row">
            <div className="col-4 col-md-4">
              <img
                src={require("../../../assests/images/Verda-HPT-Hi-Res-Logo.jpg")}
                alt="Verda Healthcare logo"
                style={{ height: 130 }}
              />
            </div>
            <div className="col-8 text-right mt-5">
              <h4 className="page-headingNA">Pre-Enrollment Qualification Assessment Form</h4>
            </div>
            <div className="col-12 ">
              {/* <h2 className="page-subheading mb-3 text-center">
              Pre-Enrollment Qualification Assessment Form
              </h2> */}
              <p>
                <b>PLEASE READ:(required for CSNP Only)</b> To enroll to Verda Healthcare’s Chronic
                Condition Special Needs Plan. We are required to confirm your
                diagnosis of a qualifying health condition. When this form is
                completed and submitted along with an enrollment application,
                you will be enrolled into Verda CSNP Plan. We will attempt to
                verify your chronic condition(s) with your provider during the
                first month of enrollment. If we are unable to verify your
                chronic condition(s), we are required to disenroll you from our
                Special Needs Plan.
              </p>
            </div>
          </div>
          {/* Your Information: start */}
          <section className="page-break-after">
            <h3 className="section-heading">Your Information</h3>
            <div className="row form-inline mt-2">
              <div className="col-12 col-md-9 mb-3">
                <fieldset className="pb-4">
                  <legend className="label-full-name">Full Name*: </legend>
                  <label className="label-type1 pb-2">
                    <i className="label-name">Last</i>{" "}
                    <input
                      onChange={handleChange}
                      type="text"
                      className="form-control form-control-sm  mr-sm-2 input-name"
                      value={lastName}
                      name="lastName"
                      id="lastName"
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />{" "}
                  </label>
                  <label className="label-type1 pb-2">
                    <i className="label-name">First</i>{" "}
                    <input
                      onChange={handleChange}
                      type="text"
                      className="form-control form-control-sm  mr-sm-2 input-name"
                      value={firstName}
                      name="firstName"
                      id="firstName"
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />{" "}
                  </label>
                  <label className="label-type1 pb-2">
                    <i className="label-name">M.I.</i>{" "}
                    <input
                      onChange={handleChange}
                      type="text"
                      className="form-control form-control-sm  mr-sm-2 input-name"
                      value={middleInitial}
                      name="middleInitial"
                      id="middleInitial"
                      maxLength={1}
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />{" "}
                  </label>
                </fieldset>
              </div>
              <div className="col-8 col-md-3 mb-3">
                <label className="label-type1">
                  Date:{" "}
                  <input
                    onChange={handleDate}
                    onClick={(e) => handleDates("date")}
                    type="text"
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    className="form-control form-control-sm  mr-sm-2 input-date scrollfix"
                    value={date}
                    name="date"
                    id="date"
                  />
                </label>
              </div>
              <div className="col-12 col-md-5 mt-2">
                <fieldset className="pb-4">
                  <legend style={{ display: "none" }} />
                  <span>
                    Gender:
                    <span className="badge badge-pill ml-4">
                      <div className="custom-control custom-checkbox custom-control-inline">
                        <input
                          onChange={handleCheckBox}
                          type="checkbox"
                          className="custom-control-checkbox"
                          id="gender_male"
                          name="gender"
                          defaultValue=""
                          value="Male"
                          checked={gender === "Male"}
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                        />
                        <label
                          className="custom-control-label1"
                          htmlFor="gender_male"
                        >
                          Male
                        </label>
                      </div>
                      <div className="custom-control custom-checkbox custom-control-inline">
                        <input
                          onChange={handleCheckBox}
                          type="checkbox"
                          className="custom-control-checkbox"
                          id="gender_female"
                          name="gender"
                          defaultValue=""
                          value="Female"
                          checked={gender === "Female"}
                        />
                        <label
                          className="custom-control-label1"
                          htmlFor="gender_female"
                        >
                          Female
                        </label>
                      </div>
                    </span>
                  </span>
                </fieldset>
              </div>
              <div className="col-12 col-md-6">
                <label className="label-type1">
                  Date of Birth*:{" "}
                  <input
                    onChange={handleDate}
                    onClick={(e) => handleDates("dateOfBirth")}
                    type="text"
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    className="form-control form-control-sm  mr-sm-2 input-date scrollfix"
                    value={dateOfBirth}
                    name="dateOfBirth"
                    id="dateOfBirth"
                  />
                </label>
              </div>
              <div className="col-md-12 mt-3">
                <h4>
                  <u>Chronic Condition Questions</u>
                </h4>
                <fieldset className="fieldset-type1 w-100 mb-2">
                  <legend>
                    <p className="mb-0">
                      If any of the following are checked, enrollee
                      pre-qualifies
                    </p>
                    <p className="mb-0">
                      Have you ever been told by a physician that you have any
                      of the following conditions*:
                    </p>
                  </legend>
                  <ul className="list-group list-group-flush ml-3">
                    <li className="list-group-item mb-1">
                      <div className="custom-control custom-checkbox custom-control-inline">
                        <input
                          onChange={handleCheckBox}
                          type="checkbox"
                          className="custom-control-checkbox"
                          id="immediate_needs"
                          name="diabetesInd"
                          defaultValue=""
                          value="Y"
                          checked={diabetesInd === "Y"}
                        />
                        <label
                          className="custom-control-label1 mt-0"
                          htmlFor="immediate_needs"
                        >
                          Diabetes Mellitus (High Blood Sugar)
                        </label>
                      </div>
                    </li>
                    <li className="list-group-item mb-1">
                      <div className="custom-control custom-checkbox custom-control-inline">
                        <input
                          onChange={handleCheckBox}
                          type="checkbox"
                          className="custom-control-checkbox"
                          id="currently_hospitalized"
                          name="chfInd"
                          defaultValue=""
                          value="Y"
                          checked={chfInd === "Y"}
                        />
                        <label
                          className="custom-control-label1 mt-0"
                          htmlFor="currently_hospitalized"
                        >
                          Chronic Heart Failure (CHF)
                        </label>
                      </div>
                    </li>
                    <li className="list-group-item mb-1">
                      <div className="custom-control custom-checkbox custom-control-inline">
                        <input
                          onChange={handleCheckBox}
                          type="checkbox"
                          className="custom-control-checkbox"
                          id="middle_of_treatment"
                          name="cardiovascularInd"
                          defaultValue=""
                          value="Y"
                          checked={cardiovascularInd === "Y"}
                        />
                        <label
                          className="custom-control-label1 mt-0"
                          htmlFor="middle_of_treatment"
                        >
                          Cardiovascular Disorders – must be one of the
                          following:
                        </label>
                      </div>
                      <ul className="list-style-disc mt-2 ml-2">
                        <li>Cardiac Arrhythmias</li>
                        <li>Coronary Artery Disease</li>
                        <li>Peripheral Vascular Disease</li>
                        <li>Chronic Venous Thromboembolic Disorder</li>
                      </ul>
                    </li>
                  </ul>
                </fieldset>
                <h4>
                  <u>Additional Questions</u>
                </h4>
                <fieldset className="fieldset-type1 w-100 mb-2 ml-3">
                  <legend className="display-contents">
                    1. Do you take any medications for the illness listed
                    above?*
                  </legend>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        onChange={handleCheckBox}
                        type="checkbox"
                        className="custom-control-checkbox"
                        id="illnessInd"
                        name="illnessInd"
                        defaultValue=""
                        value="Y"
                        checked={illnessInd === "Y"}
                      />
                      <label
                        className="custom-control-label1"
                        htmlFor="illnessInd"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        onChange={handleCheckBox}
                        type="checkbox"
                        className="custom-control-checkbox"
                        id="do_you_take_any_medications_no"
                        name="illnessInd"
                        defaultValue=""
                        value="N"
                        checked={illnessInd === "N"}
                      />
                      <label
                        className="custom-control-label1"
                        htmlFor="do_you_take_any_medications_no"
                      >
                        No
                      </label>
                    </div>
                  </span>
                </fieldset>
                <fieldset className="fieldset-type1 w-100 mb-2 ml-3">
                  <legend className="display-contents">
                    2. Have you ever been taking Metformin or Insulin
                    Injection?*
                  </legend>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        onChange={handleCheckBox}
                        type="checkbox"
                        className="custom-control-checkbox"
                        id="taking_metformin_yes"
                        name="insulinInd"
                        defaultValue=""
                        value="Y"
                        checked={insulinInd === "Y"}
                      />
                      <label
                        className="custom-control-label1"
                        htmlFor="taking_metformin_yes"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        onChange={handleCheckBox}
                        type="checkbox"
                        className="custom-control-checkbox"
                        id="taking_metformin_no"
                        name="insulinInd"
                        defaultValue=""
                        value="N"
                        checked={insulinInd === "N"}
                      />
                      <label
                        className="custom-control-label1"
                        htmlFor="taking_metformin_no"
                      >
                        No
                      </label>
                    </div>
                  </span>
                </fieldset>
                <fieldset className="fieldset-type2 w-100 mb-2">
                  <legend>
                    Please checked all medications you ever been taking below:
                  </legend>
                  <div className="ml-2">
                    {medicationVals.map((medication1) => (
                      <span className="badge badge-pill mr-2" key={medication1}>
                        <div className="custom-control custom-checkbox custom-control-inline pl-0">
                          <input
                            onChange={handleCheckBox}
                            type="checkbox"
                            className="custom-control-checkbox"
                            id={medication1}
                            name={medication1}
                            defaultValue=""
                            value={medication1}
                            checked={medications.some((m) => m === medication1)}
                          />
                          <label
                            className="custom-control-label1"
                            htmlFor={medication1}
                          >
                            {medication1}
                          </label>
                        </div>
                      </span>
                    ))}
                  </div>
                </fieldset>
                <fieldset className="fieldset-type2 w-100 mb-2">
                  <legend>Others:</legend>
                  <div className="ml-2">
                    <span className="badge badge-pill w-30">
                      <div className="custom-control custom-checkbox custom-control-inline w-100 pl-0">
                        <input
                          onChange={handleCheckBox}
                          type="checkbox"
                          className="custom-control-checkbox"
                          id="other1"
                          name="other1"
                          defaultValue=""
                          value="Y"
                          checked={other1 === "Y"}
                        />
                        <label
                          className="custom-control-label1"
                          htmlFor="other1"
                        >
                          <input
                            onChange={handleChange}
                            type="text"
                            className="form-control"
                            id="otherMed1"
                            name="otherMed1"
                            value={otherMed1}
                            disabled={other1 !== "Y"}
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                          />
                        </label>
                      </div>
                    </span>
                    <span className="badge badge-pill w-30">
                      <div className="custom-control custom-checkbox custom-control-inline pl-0">
                        <input
                          onChange={handleCheckBox}
                          type="checkbox"
                          className="custom-control-checkbox"
                          id="other2"
                          name="other2"
                          defaultValue=""
                          value="Y"
                          checked={other2 === "Y"}
                        />
                        <label
                          className="custom-control-label1"
                          htmlFor="other2"
                        >
                          <input
                            onChange={handleChange}
                            type="text"
                            className="form-control"
                            id="otherMed2"
                            name="otherMed2"
                            value={otherMed2}
                            disabled={other2 !== "Y"}
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                          />
                        </label>
                      </div>
                    </span>
                    <span className="badge badge-pill w-30">
                      <div className="custom-control custom-checkbox custom-control-inline pl-0">
                        <input
                          onChange={handleCheckBox}
                          type="checkbox"
                          className="custom-control-checkbox"
                          id="other3"
                          name="other3"
                          defaultValue=""
                          value="Y"
                          checked={other3 === "Y"}
                        />
                        <label
                          className="custom-control-label1"
                          htmlFor="other3"
                        >
                          <input
                            onChange={handleChange}
                            type="text"
                            className="form-control"
                            id="otherMed3"
                            name="otherMed3"
                            value={otherMed3}
                            disabled={other3 !== "Y"}
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                          />
                        </label>
                      </div>
                    </span>
                    <span className="badge badge-pill w-30">
                      <div className="custom-control custom-checkbox custom-control-inline pl-0">
                        <input
                          onChange={handleCheckBox}
                          type="checkbox"
                          className="custom-control-checkbox"
                          id="other4"
                          name="other4"
                          defaultValue=""
                          value="Y"
                          checked={other4 === "Y"}
                        />
                        <label
                          className="custom-control-label1"
                          htmlFor="other4"
                        >
                          <input
                            onChange={handleChange}
                            type="text"
                            className="form-control"
                            id="otherMed4"
                            name="otherMed4"
                            value={otherMed4}
                            disabled={other4 !== "Y"}
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                          />
                        </label>
                      </div>
                    </span>
                    <span className="badge badge-pill w-30">
                      <div className="custom-control custom-checkbox custom-control-inline pl-0">
                        <input
                          onChange={handleCheckBox}
                          type="checkbox"
                          className="custom-control-checkbox"
                          id="other5"
                          name="other5"
                          defaultValue=""
                          value="Y"
                          checked={other5 === "Y"}
                        />
                        <label
                          className="custom-control-label1"
                          htmlFor="other5"
                        >
                          <input
                            onChange={handleChange}
                            type="text"
                            className="form-control"
                            id="otherMed5"
                            name="otherMed5"
                            value={otherMed5}
                            disabled={other5 !== "Y"}
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                          />
                        </label>
                      </div>
                    </span>
                    <span className="badge badge-pill w-30">
                      <div className="custom-control custom-checkbox custom-control-inline pl-0">
                        <input
                          onChange={handleCheckBox}
                          type="checkbox"
                          className="custom-control-checkbox"
                          id="other6"
                          name="other6"
                          defaultValue=""
                          value="Y"
                          checked={other6 === "Y"}
                        />
                        <label
                          className="custom-control-label1"
                          htmlFor="other6"
                        >
                          <input
                            onChange={handleChange}
                            type="text"
                            className="form-control"
                            id="otherMed6"
                            name="otherMed6"
                            value={otherMed6}
                            disabled={other6 !== "Y"}
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                          />
                        </label>
                      </div>
                    </span>
                  </div>
                </fieldset>
              </div>
            </div>
          </section>
          {/* Your Information: end */}
        </div>
        <div className="page">
          {/* Primary Care Physicians: start */}
          <section className="mt-3">
            <h3 className="section-heading">
              **REQUIRED** Current Treating Physician
            </h3>
            <div className="row form-inline mt-2">
              <div className="col-12 col-md-6 mb-3">
                <label className="label-type1">
                  Provider Name*:{" "}
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control form-control-sm  mr-sm-2 w-100"
                    id="pcpProviderName"
                    name="pcpProviderName"
                    value={pcpProviderName}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </label>
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label className="label-type1">
                  Address*:{" "}
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control form-control-sm  mr-sm-2 w-100"
                    id="pcpAddress"
                    name="pcpAddress"
                    value={pcpAddress}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </label>
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label className="label-type1">
                  Phone Number*:{" "}
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control form-control-sm  mr-sm-2 w-100"
                    id="pcpPhoneNum"
                    name="pcpPhoneNum"
                    value={pcpPhoneNum}
                    maxLength={10}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </label>
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label className="label-type1">
                  Fax Number:{" "}
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control form-control-sm  mr-sm-2 w-100"
                    id="pcpFaxNum"
                    name="pcpFaxNum"
                    value={pcpFaxNum}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </label>
              </div>
            </div>
          </section>
          {/* Primary Care Physicians: end */}
          {/* Specialist: start */}
          <section>
            <h3 className="section-heading">
              ** REQUIRED** Current Specialist (If none, write N/A){" "}
            </h3>
            <div className="row form-inline mt-2">
              <div className="col-12 col-md-6 mb-3">
                <label className="label-type1">
                  Specialist Name*:{" "}
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control form-control-sm  mr-sm-2 w-100"
                    id="specialistName"
                    name="specialistName"
                    value={specialistName}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </label>
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label className="label-type1">
                  Address*:{" "}
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control form-control-sm  mr-sm-2 w-100"
                    id="specialistAddress"
                    name="specialistAddress"
                    value={specialistAddress}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </label>
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label className="label-type1">
                  Phone Number*:{" "}
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control form-control-sm  mr-sm-2 w-100"
                    id="specialistPhoneNum"
                    name="specialistPhoneNum"
                    value={specialistPhoneNum}
                    maxLength={10}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </label>
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label className="label-type1">
                  Fax Number:{" "}
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control form-control-sm  mr-sm-2 w-100"
                    id="specialistFaxNum"
                    name="specialistFaxNum"
                    value={specialistFaxNum}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </label>
              </div>
            </div>
          </section>
          {/* Specialist: end */}
          {/* Disclaimer and Signature:start */}
          <section>
            <h3 className="section-heading">Disclaimer and Signature</h3>
            <div className="row mt-2">
              <div className="col-md-12">
                <h6>
                  <i>
                    Authorization for Disclosure of Health Information to verify
                    Chronic Condition(s):
                  </i>
                </h6>
                <p>
                  <i>
                    I hereby authorize the disclosure of my health information
                    by the providers listed above to Verda Healthcare in order
                    to verify that I have been diagnosed with a chronic
                    condition which qualifies me for enrollment in a Verda
                    Special Needs Plan. This authorization applies to all health
                    information maintained by the provider concerning my medical
                    history for the chronic condition(s) indicated above.
                  </i>
                </p>
                <br />
                <p>
                  <i>
                    <strong>Note:</strong> Information disclosed as a result of
                    this authorization will be protected by Verda Healthcare in
                    accordance with applicable state and federal laws and
                    requirements.
                  </i>
                </p>
                <div className="row form-inline mt-2 mb-4">
                  <div className="col-md-4">
                    <label className="label-type1">
                      Enrollee Signature:{" "}
                      <input
                        onChange={handleChange}
                        type="text"
                        className="form-control form-control-sm  mr-sm-2 w-100 height-50"
                        id="enrolleeSignature"
                        name="enrolleeSignature"
                        value={enrolleeSignature}
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                      />
                    </label>
                  </div>
                  <div className="col-md-5">
                    <label className="label-type1">
                      Digital Signature:{" "}
                      <input
                        onChange={handleChange}
                        type="text"
                        className="form-control form-control-sm  mr-sm-2 w-100 height-50"
                        id="enrolleeSignature"
                        name="enrolleeSignature"
                        value={enrolleeSignature}
                        disabled
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                      />
                    </label>
                  </div>
                  <div className="col-md-3">
                    <label className="label-type1">
                      Date:{" "}
                      <input
                        // onChange={handleDate}
                        // onClick={(e) => handleDates("signDate")}
                        type="text"
                        className="form-control form-control-sm  mr-sm-2 w-100 height-50"
                        id="signDate"
                        name="signDate"
                        value={
                          new Date()
                            .toLocaleString("en-US", {
                              timeZone:
                                Intl.DateTimeFormat().resolvedOptions()
                                  .timeZone,
                            })
                            .split(",")[0]
                        }
                        disabled
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                      />
                    </label>
                  </div>
                  <p className="col-md-12 mt-5 text-danger">
                    Please fill all mandatory fields marked as *{" "}
                  </p>
                </div>
              </div>
            </div>
          </section>
          {/* Disclaimer and Signature:end */}
          <div className="mt-2 mb-2 text-center screen-only">
            <button
              type="submit"
              className="btn btn-primary mr-3"
              disabled={disableFlag}
              onClick={submitHandler}
            >
              Submit
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary mr-3"
              onClick={props.cancel}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};
